import React from 'react';
import map from 'assets/MAP.jpg'
import './styles.scss';
import World from 'assets/World';
import CallChat from 'assets/CallChat';
import Mail from 'assets/Mail';
import Twitter from 'assets/Twitter';
import LinkedIn from 'assets/LinkedIn';
import Facebook from 'assets/Facebook';

const ContactUsSection = () => {
    return (
        <div className='__ContactUsSection position-relative text-center font_lato'>
            <img src={map} alt="" className='d-block w-100 __map-image' />
            <div className='__contact-us-card text-center'>
                <h1 className='font_montserrat mt-0 mb-3 font-weight-semi-bold __primary-text-color position-relative __title'>Contact Us</h1>
                <p className='__subtitle'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod</p>
                <div className='align-items-end space-evenly __contact-us-section'>
                    <a href="tel:+923476262068">
                        <World />
                        <div className='mt-1'>London, UK</div>
                    </a>
                    <a href="tel:+923476262068">
                        <CallChat />
                        <div className='mt-1'>Talk to Us</div>
                    </a>
                    <a href="mailto:m.ubaidbadar@gmail.com">
                        <Mail className='__mail-icon' />
                        <div className='mt-1'>Talk to Us</div>
                    </a>
                </div>
                <h4 className='__h4 font-montserrat font-weight-mediam-bold __primary-text-color'>Duis aute irure dolor in  in voluptate velit esse dolore eu fugiat nulla pariatur. </h4>
                <div className='__social-links-wrapper align-items-center'>
                    <a href="https://twitter.com/"><Twitter /></a>
                    <a href="https://facebook.com/"><Facebook /></a>
                    <a href="https://linkedin.com/" className='__linkdn-icon'><LinkedIn /></a>
                </div>
            </div>
        </div>
    )
}

export default ContactUsSection;